import { httprequest } from "../../../../data/api";

const UPLOAD_ENDPOINT = "/api/v1/upload";

const uploadFile = async (file, title) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
  const uploaded = response?.data?.data?.[0];

  return {
    title: title || file?.name,
    file_name: file?.name,
    file_url: uploaded?.file_url,
    file_size: file?.size,
    key: uploaded?.key
  };
};

export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getFileMeta = (fileName) => {
  const extension = (fileName || "").split(".").pop()?.toLowerCase();

  if (extension === "pdf") {
    return { icon: "mdi:file-pdf-box", label: "PDF", bg: "#FEF3F2", color: "#D92D20" };
  }
  if (["png", "jpg", "jpeg", "gif", "svg"].includes(extension)) {
    return { icon: "mdi:file-image-outline", label: extension.toUpperCase(), bg: "#F2F4F7", color: "#475467" };
  }
  if (["mp4", "webm", "mov"].includes(extension)) {
    return { icon: "mdi:file-video-outline", label: extension.toUpperCase(), bg: "#F4F3FF", color: "#6938EF" };
  }
  if (["doc", "docx"].includes(extension)) {
    return { icon: "mdi:file-word-outline", label: "DOCX", bg: "#EFF8FF", color: "#175CD3" };
  }

  return { icon: "mdi:file-outline", label: extension?.toUpperCase() || "FILE", bg: "#F2F4F7", color: "#475467" };
};

export default uploadFile;
